import * as React from "react";

import { ApiEndpointContextProvider } from "@cak-legacy/pilet-core";
import { Language } from "@cak-legacy/shared-locales";
import { translate } from "@klantondersteuning-btl/shared";

import { IntroEN } from "../component/intro-en";
import { IntroNL } from "../component/intro-nl";
import { PrivacyEN } from "../component/privacy-en";
import { PrivacyNL } from "../component/privacy-nl";
import { EhicFormulierContainer } from "../container/EhicFormulierContainer";
import { IEhicFormulierPageProps } from "../interfaces/ehic-formulier-page";

export default (props: IEhicFormulierPageProps) => {
  React.useEffect(() => {
    document.title = `CAK - ${translate("EhicFormulier")}`;
  }, []);

  const IntroText = () => (props.language === Language.Nederlands ? <IntroNL /> : <IntroEN />);
  const PrivacyText = () => (props.language === Language.Nederlands ? <PrivacyNL /> : <PrivacyEN />);

  return (
    <ApiEndpointContextProvider value={props.apiUrl}>
      <EhicFormulierContainer
        {...props}
        formulierKenmerk={"Ehic"}
        introText={<IntroText />}
        introConfirmPageText={
          <div className="pt-4 intro">
            <h1>{translate("EhicFormulier")}</h1>
          </div>
        }
      />
      <PrivacyText />
    </ApiEndpointContextProvider>
  );
};
